var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTemplate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 1H2.4375C1.91973 1 1.5 1.41973 1.5 1.9375V3.8125C1.5 4.33027 1.91973 4.75 2.4375 4.75H15.5625C16.0803 4.75 16.5 4.33027 16.5 3.8125V1.9375C16.5 1.41973 16.0803 1 15.5625 1Z",
    stroke: "#A5A5A5",
    strokeWidth: 1.2,
    strokeMiterlimit: 16,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 8.5H2.4375C1.91973 8.5 1.5 8.91973 1.5 9.4375V15.0625C1.5 15.5803 1.91973 16 2.4375 16H6.1875C6.70527 16 7.125 15.5803 7.125 15.0625V9.4375C7.125 8.91973 6.70527 8.5 6.1875 8.5Z",
    stroke: "#A5A5A5",
    strokeWidth: 1.2,
    strokeMiterlimit: 16,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 8.5H16.5",
    stroke: "#A5A5A5",
    strokeWidth: 1.2,
    strokeMiterlimit: 16,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 12.25H16.5",
    stroke: "#A5A5A5",
    strokeWidth: 1.2,
    strokeMiterlimit: 16,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 16H16.5",
    stroke: "#A5A5A5",
    strokeWidth: 1.2,
    strokeMiterlimit: 16,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTemplate);
export default __webpack_public_path__ + "static/media/icon-template.af3a2ce2b6a72176a03aaa044a94708f.svg";
export { ForwardRef as ReactComponent };